export default {
    i18n: {
        "handset": "Трубка",
        "day": "день",
        "bluetooth": "Bluetooth",
        "Device Information": "Інформація про пристрій",
        "tamperAlarm": "Сигналізація втручання",
        "Card": "Картка",
        "Fingerprint": "Відбитки пальців",
        "Date Time": "Дата час",
        "name": "ім\'я",
        "Http": "HTTP",
        "Device Name": "Назва пристрою",
        "auto": "Авто",
        "Group": "Група",
        "Volume": "Гучність",
        "minutes": "хвилин",
        "timezone": "часовий пояс",
        "Are you sure you want to delete this device?": "Видалити цей пристрій?",
        "Attendance Point Name": "Назва пункту відвідування",
        "Mac": "MAC",
        "confirmToDeleteIt?": "Видалити?",
        "captureLogs": "Журнал знімків",
        "Doors": "Двері",
        "All Doors": "Всі двері",
        "Lock List": "Список замків",
        "Link Device Relay": "Прив\'язати реле пристрою",
        "Added Successfully!": "Успішно додано!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Коли замок прив’язаний до реле, замок буде розблоковано при спрацьовуванні реле.",
        "Adding...": "Додавання...",
        "Please try again 24 hours later.": "Повторіть спробу через 24 години.",
        "Action": "Дія",
        "unlock": "Відкрити",
        "Address": "Адреса",
        "Owner": "Власник",
        "Failed": "Не вдалося",
        "Timeout": "Таймаут",
        "Response": "Відповідь",
        "caller": "Викликаючий",
        "receiver": "Приймач",
        "doorLogs": "Журнал відчинення дверей",
        "callHistory": "Історія викликів",
        "UID": "ID користувача",
        "Call Type": "Тип дзвінка",
        "Code": "Код",
        "User": "Користувач",
        "Device List": "Список пристроїв",
        "Model": "Модель",
        "Time": "Час",
        "Company": "Компанія",
        "Property Managers": "Адміністратори",
        "Current Version": " Поточна версія",
        "indoorMonitor": "Монітор",
        "guardPhone": "Телефон охорони",
        "close": "Зачинено",
        "Success": "Успішно",
        "URL": "URL",
        "Please select a device.": "Виберіть пристрій.",
        "Password is too weak.": "Пароль занадто слабкий.",
        "Company is required.": "Потрібно вказати компанію.",
        "Your account is not activated, please contact your service provider.": "Ваш обліковий запис не активовано, зверніться до свого постачальника послуг.",
        "Language": "Мова",
        "Face": "Обличчя",
        "Please set at least one access type.": "Встановіть принаймні один тип доступу.",
        "Please contact your service provider to activate this advanced feature.": "Щоб активувати цю розширену функцію, зверніться до свого постачальника послуг.",
        "Community name": "Ім\'я спільноти",
        "Please enable PM App first.": "Спочатку ввімкніть застосунок Адміністратора.",
        "Username": "Ім\'я користувача",
        "Change Log": "Журнал змін",
        "Assign": "Призначити",
        "Floor": "Поверх",
        "Link Device": "Прив\'язати пристрій",
        "Accessible Floors": "Доступні поверхи",
        "Upgrade": "Оновлення",
        "Function": "Функція",
        "callDuration": "Тривалість виклику",
        "No": "Ні",
        "Verification Code": "Код підтвердження",
        "Expiration Time": "Термін дії до",
        "PIN": "PIN-код",
        "MAC": "MAC-адреса",
        "Building": "Будинок",
        "APT": "КВ",
        "ID": "ID",
        "Name": "Назва",
        "activities": "Дії",
        "Obtain": "Отримати",
        "call": "Виклик",
        "Group Call": "Групповий виклик",
        "Delete": "Видалити",
        "Yes": "Так",
        "Door Release PIN": "PIN-код відчинення дверей",
        "Email": "Електронна пошта",
        "Mobile Number doesn\'t exist.": "Мобільний номер не існує.",
        "Tips": "Поради",
        "Password": "Пароль",
        "The end time cannot be earlier than the start time.": "Час закінчення не може бути раніше часу початку.",
        "Back": "Назад",
        "File format error.": "Помилка формату файлу.",
        "motionDetection": "Виявлення руху",
        "You are trying too often, please try again in 5 minutes": "Ви намагаєтеся занадто часто, спробуйте ще раз через 5 хвилин",
        "User name too long.": "Ім\'я користувача занадто довге.",
        "This MAC address is redirected on RPS.": "Ця MAC-адреса перенаправляється на RPS.",
        "No Answer": "Немає відповіді",
        "failedToUnlock": "Не вдалося розблокувати",
        "visitor": "відвідувач",
        "yesterday": "Вчора",
        "Too large data! Please first export the data before %s first,thanks.": "Занадто великі дані! Спочатку експортуйте дані перед %s.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Перевірте, чи є неоплачені замовлення, якщо ні, зверніться до свого постачальника послуг",
        "lock": "Зачинити двері",
        "open": "Відчинено",
        "The PersonalAccount is not active.": "Персональний акаунт не активний.",
        "You cannot link an account that already link other accounts.": "Ви не можете прив\'язати акаунт, який вже прив\'язаний до інших акаунтів.",
        "You cannot link multiple property manager accounts under the same installer account.": "Ви не можете прив’язати кілька облікових записів адміністратора з одним обліковим записом інсталятора.",
        "You cannot link to the currently logged in account.": "Ви не можете прив’язати до облікового запису, в який ви увійшли.",
        "nfc": "NFC",
        "Delete Device": "Видалити проистрій",
        "date": "Дата",
        "Device deleted successfully": "Пристрій успішно видалено",
        "Failed to delete device": "Не вдалося видалити пристрій",
        "Are you sure you want to cancel?": "Скасувати?",
        "Unlimited": "Необмежено",
        "Battery Level": "Рівень заряду батареї",
        "Password Incorrect.": "Пароль Неправильний.",
        "deliverySystemVerification": "Перевірка системи доставки",
        "Upgrading...": "Оновлення...",
        "amenityReservation": "Перелік відвідувань",
        "idAccess": "ID доступ",
        "RF Card": "RF-карта",
        "exitButton": "Кнопка відкривання дверей",
        "Please select at least one item.": "Виберіть принаймні один елемент.",
        "The ID can contain only digits and letters, up to 32 characters.": "Ідентифікатор може містити лише цифри та літери, до 32 символів.",
        "The PIN is not available.": "PIN-код недоступний.",
        "Change WiFi": "Змінити WiFi",
        "Access Denied.": "Не вдалося відкрити двері.",
        "None": "Немає",
        "Phone number": "Номер телефону",
        "Invalid {0}.": "Недійсний {0}.",
        "{0} already exists.": "{0} вже існує.",
        "Operation failed!": "Помилка операції!",
        "Failed to get data.": "Помилка отримання даних.",
        "You do not have the necessary permissions to perform this operation.": "Ви не маєте необхідних дозволів для виконання цієї операції.",
        "You can only import one template at a time in the current site.": "Ви можете імпортувати лише один шаблон за раз для поточного об\'єкту.",
        "Delivery name": "Ім\'я доставки",
        "MAC address not in the MAC library.": "MAC-адреси немає в бібліотеці MAC-адрес.",
        "Please delete devices under this building.": "Видаліть пристрої цієї будівлі.",
        "The start time cannot be later than the end time.": "Час початку не може бути пізнішим за час закінчення.",
        "emergency action type": "тип екстреної дії",
        "Only 1000 data items can be imported at a time.": "За один раз можна імпортувати лише 1000 елементів даних.",
        "The password is too short.": "Пароль занадто короткий.",
        "The data has been updated. Please refresh the page and try again.": "Дані були оновлені. Будь ласка, оновіть сторінку та спробуйте ще раз.",
        "AutoP length must be less 2048 bytes.": "Довжина AutoP має бути менше 2048 байт.",
        "File Check Failed": "Помилка перевірки файлу",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Термін дії облікового запису адміністратора закінчився. Зверніться до свого постачальника послуг.",
        "iqPinVerificationFailed": "Перевірка IQ PIN не пройшла.",
        "accountBlacklisted": "Акаунт у чорному списку.",
        "outsideAuthorizedTime": "Поза межами дозволеного часу.",
        "network group": "мережева група",
        "Company name": "Назва компанії",
        "Group name": "Назва групи",
        "relay": "реле",
        "motionTime": "Час руху",
        "motionType": "Тип руху",
        "postalCode": "Поштовий індекс",
        "floor format": "формат поверху",
        "mobilePhone": "мобільний телефон",
        "time format": "формат часу",
        "security relay": "реле безпеки",
        "Param": "Параметр",
        "Offline Code": "Офлайн код",
        "Add akubela Smart Locks": "Додати смарт-замки Akubela",
        "Module Version": "Версія модуля",
        "Lock Body Version": "Версія замку",
        "Available Version": "Доступна версія",
        "Please wake up the lock screen and then upgrade.": "Увімкніть екран блокування, а потім виконайте оновлення.",
        "This process will take some time, please be patient.": "Цей процес займе деякий час, будь ласка, зачекайте.",
        "Please confirm that the WiFi network is functioning properly.": "Переконайтеся, що мережа WiFi працює належним чином.",
        "Please wake up the lock screen.": "Увімкніть екран блокування.",
        "This lock has already been added to another apartment.": "Цей замок вже доданий до іншої квартири.",
        "This lock has already been added to the apartment.": "Цей замок вже доданий до квартири.",
        "Pin Code": "PIN-код",
        "Too many failed attempts, please try again in a few minutes.": "Занадто багато невдалих спроб, спробуйте ще раз через кілька хвилин.",
        "Login Account": "Вхід до акаунту",
        "Same account cannot login in different ins.": "Один обліковий запис не може увійти до різних інсталяторів.",
        "Lock Name": "Назва замка",
        "Smart Locks": "Смарт-замки",
        "Add Smart Lock": "Додати смарт-замок",
        "The selected duration cannot be more than one year.": "Вибрана тривалість не може бути більше одного року.",
        "The end time of the break time cannot be later than the end work time.": "Час закінчення перерви не може бути пізніше часу закінчення роботи.",
        "The start time of the break time cannot be earlier than the start work time.": "Час початку перерви не може бути раніше часу початку роботи.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Час закінчення дійсного контрольного часу не може бути ранішим за час закінчення роботи.",
        "The start time of the valid check time cannot be later than the start work time.": "Час початку дійсного контрольного часу не може бути пізнішим за час початку роботи.",
        "Deleting failed. The timetable is used by a shift.": "Помилка видалення. Розклад використовується зміною.",
        "Deleting failed. The shift is in use.": "Помилка видалення. Зміна використовується.",
        "Deleting failed. The leave type is in use.": "Видалити не вдалося. Тип відсутності використовується.",
        "Valid time conflicts with an existing schedule.": "Дійсний час конфліктує з наявним розкладом.",
        "The timing for multiple schedules must not coincide.": "Часові рамки для кількох графіків не повинні збігатися.",
        "Attendance Log": "Журнал відвідуваності",
        "Added Failed!": "Не вдалося додати!",
        "Setting WiFi": "Налаштування WiFi",
        "License Plate": "Номер авто",
        "key": "Ключ",
        "IQ Offline.": "IQ офлайн.",
        "{0}Unlock": "{0} розблоковано",
        "automatically": "Автоматично",
        "manually": "Вручну",
        "Video Storage": "Сховище відео",
        "Device(s) for Video Storage": "Пристрої для відеосховища",
        "The amount of exported data is too large. Please export it in batches.": "Обсяг експортованих даних занадто великий. Будь ласка, експортуйте їх частинами.",
        "Auto-record video when door unlocks": "Автозапис відео при розблокуванні дверей",
        "Auto-record video during calls": "Автозапис відео під час викликів",
        "Manual video recording in monitoring": "Ручний запис відео під час моніторингу",
        "Saved for 30days/60days/90days": "Збережено на 30 днів/60 днів/90 днів",
        "To subscribe, please contact your provider for activation.": "Щоб підписатися, зверніться до свого постачальника послуг для активації.",
        "Saved for {0}days": "Збережено на {0} днів",
        "Subscribed Plan": "План підписки",
        "Supported Devices: {0}": "Підтримувані пристрої: {0}",
        "{0}Lock": "{0} заблоковано",
        "Video Saving": "Зберігання відео",
        "Download Completed!": "Завантаження завершено!",
        "Fail to download.": "Завантажити не вдалося.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Помилка видалення! Менеджера нерухомості було прив\'язано до клієнта Менеджера оренди, спочатку слід видалити його.",
        "No log to be exported.": "Немає журналу для експорту.",
        "capture&Video": "Знімки та відео",
        "packageDetection": "Виявлення пакунку",
        "Time format is invalid.": "Невірний формат часу.",
        "No permission to export logs of this type.": "Немає дозволу на експорт журналів цього типу.",
        "Project type is invalid.": "Недійсний тип проєкту.",
        "Salto Account Blocked.": "Акаунт Salto заблоковано.",
        "Remote open not in access group.": "Віддалене відчинення не в групі доступу.",
        "SIP Account required.": "Потрібен SIP-акаунт.",
        "The PIN must be {0} digits.": "PIN-код повинен складатися з {0} цифр.",
        "gatewayConnectionUnavailable": "З\'єднання зі шлюзом відсутнє.",
        "Invalid Username or Password": "Недійсне ім\'я користувача чи пароль",
        "Account already linked to another user.": "Акаунт вже пов\'язаний з іншим користувачем.",
        "The account has been added by another user.": "Акаунт вже доданий іншим користувачем.",
        "Failed to add. This user already has 5 license plates.": "Не вдалося додати. Цей користувач вже має 5 номерів авто.",
        "Please at least select a door.": "Виберіть принаймні двері.",
        "UHF Card": "UHF-картка",
        "personnel": "персонал",
        "Parking Lot Name": "Назва паркінгу",
        "Controlled Relay": "Кероване реле",
        "No Permission": "Немає дозволу",
        "Please ensure that all doors in the project are activated at the same time.": "Переконайтеся, що всі двері в проєкті активовані одночасно.",
        "gatewayBusy": "Шлюз зайнято",
        "Please set the perimeter door group first.": "Спочатку встановіть дверну групу периметра.",
        "Please ensure that all doors in the project are renewed at the same time.": "Переконайтеся, що всі двері в проєкті поновлені одночасно.",
        "When lockdown is on, the controlled relay cannot be modified.": "Коли блокування активовано, кероване реле не може бути змінено.",
        "DetectionLogs": "Журнали виявлення",
        "packageIn": "Посилка покладена",
        "packageOut": "Посилка забрана",
        "View Progress": "Перегляд прогресу",
        "Check if the WiFi is operating on the 2.4GHz band.": "Перевірте, чи Wi-Fi працює в діапазоні 2,4 ГГц.",
        "Verify that the WiFi password is correct.": "Перевірте правильність пароля WiFi.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Переконайтеся, що ви підключені до вірної точки доступу під час її налаштування.",
        "Offline Code Unlock": "Розблокування за офлайн кодом",
        "Salto Token Expired.": "Термін дії токена Salto закінчився.",
        "Lock Offline": "Замок офлайн",
        "identity information! Please login again": "Інформація про ідентифікацію! Будь ласка, увійдіть знову",
        "Email is required.": "Потрібна електронна пошта.",
        "Mobile number is required.": "Потрібен номер мобільного телефону.",
        "You can\'t make payments for offices in different time zones.": "Ви не можете здійснювати платежі за офіси в різних часових поясах.",
        "The current scheduling staff exceeds 200 people.": "Поточний персонал, який займається розкладом, перевищує 200 осіб.",
        "param": "параметр",
        "Invalid UserName or Password": "Неправильне ім’я користувача або пароль",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Ваш обліковий запис Salto KS не має дозволу змінювати назву замка.",
        "Owner is required.": "Потрібен власник.",
        "Office is required.": "Потрібен офіс.",
        "PIN or RF Card is required.": "Потрібен PIN-код або RF-картка.",
        "RF card": "RF-карта",
        "Personnel is required.": "Потрібен персонал.",
        "email address": "електронна адреса",
        "mobile number": "мобільний номер",
        "The length must be less than 32 characters.": "Довжина має бути меншою за 32 символи.",
        "The length must be less than 256 characters.": "Довжина має бути меншою за 256 символів.",
        "Access Group is required.": "Потрібна група доступу.",
        "Device is required.": "Потрібен пристрій.",
        "Admin is required.": "Потрібен адміністратор.",
        "Mobile number": "Мобільний номер",
        "schedules": "розклади",
        "Timetable name": "Назва розкладу",
        "Shift name": "Назва зміни",
        "Leave type": "Тип відпустки",
        "recheck in time": "час повторної реєстрації",
        "recheck out time": "час повторної реєстрації виходу",
        "The building name": "Назва будівлі",
        "Building is required.": "Потрібна будівля.",
        "selection, The same reader cannot be set for both entry and exit": "вибір, Один і той самий зчитувач не може бути встановлений для входу і виходу",
        "Door number": "Номер дверей",
        "door input cannot be selection duplicated.": "Вхід дверей не може бути вибраний повторно.",
        "Group is required.": "Потрібна група.",
        "Title can contain up to 32 characters.": "Назва може містити до 32 символів.",
        "Content can contain up to 1024 characters.": "Вміст може містити до 1024 символів.",
        "Content can contain up to 64 characters.": "Вміст може містити до 64 символів.",
        "Report is required.": "Потрібен звіт.",
        "ID is required.": "Потрібен ID.",
        "The office does not exist.": "Офіс не існує.",
        "Office name": "Назва офісу",
        "The Temp Key does not exist.": "Тимчасовий ключ не існує.",
        "autolock time": "час автозаблокування",
        "The User does not exist.": "Користувача не існує.",
        "The Installer does not exist.": "Інсталятор не існує.",
        "The Project does not exist.": "Проєкт не існує.",
        "The Distributor does not exist.": "Дистриб’ютор не існує.",
        "The Community Device does not exist.": "Пристрій спільноти не існує.",
        "The Property Manager does not exist.": "Адміністратора спільноти не існує.",
        "The Sub Distributor does not exist.": "Субдистриб\'ютора не існує.",
        "The Single Slave does not exist.": "Окремого підлеглого облікового запису не існує.",
        "The Property Manager EndUser does not exist.": "Кінцевий користувач Property Manager не існує.",
        "The Family Member does not exist.": "Член сім\'ї не існує.",
        "Set Failed!": "Помилка встановлення!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Досягнено ліміту в 10 запитів коду доступу протягом 30 хвилин. Спробуйте пізніше.",
        "This Email doesn\'t exist.": "Ця електронна адреса не існує.",
        "detection type": "тип виявлення",
        "Device UUID": "UUID пристрою",
        "smart lock device": "розумний замок",
        "You are trying too often, please try again in 5 minutes.": "Ви занадто часто намагаєтесь, будь ласка, спробуйте ще раз через 5 хвилин.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Ви можете імпортувати лише один файл за раз. Будь ласка, дочекайтеся завершення поточного імпорту.",
        "NVR Name": "Назва NVR",
        "NVR Address": "Адреса NVR",
        "Stay Alarm": "Сигнал про довгу присутність",
        "Happended On": "Сталося",
        "Edit Milesight NVR": "Редагувати Milesight NVR",
        "Add Milesight NVR": "Додати Milesight NVR",
        "Auto-record video on motion detection, package detection": "Автоматично записувати відео при виявленні руху чи пакунка",
        "A 7-day free trial is included with your subscription.": "До підписки входить 7-денна безкоштовна пробна версія.",
        "For service renewal, please reach out to your provider.": "Для продовження послуги зверніться до свого провайдера.",
        "Allow the Property Manager to view recorded videos": "Дозволити менеджеру нерухомості переглядати записані відео",
        "Please ensure the WiFi network is working properly.": "Переконайтеся, що WiFi-мережа працює належним чином.",
        "Edit akubela Smart Locks": "Редагувати розумний замок akubela",
        "Upgraded Successfully!": "Оновлення успішне!",
        "Upgraded Failed!": "Помилка оновлення!",
        "Editing...": "Редагування...",
        "Edited successfully!": "Успішно відредаговано!",
        "Edited Failed!": "Помилка редагування!",
        "Downloading video...": "Завантаження відео...",
        "All Locks": "Всі замки",
        "Select Locks": "Вибрати замки",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "PIN-код із {0} цифрами можна використовувати після підключення розумного замка akubela до мережі. Зверніть увагу, що після синхронізації PIN-код може стати чинним із затримкою.",
        "Please at least select a door or a lock.": "Будь ласка, виберіть хоча б двері або замок.",
        "This lock has already been added to your apartment.": "Цей замок вже доданий до вашої квартири.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Цей замок вже доданий до іншої квартири, зверніться до свого постачальника послуг за допомогою.",
        "LockBody Version": "Версія корпусу замка",
        "Two-factor Authentication": "Двофакторна автентифікація",
        "Monitoring Scope": "Зона моніторингу",
        "Stay Duration": "Тривалість перебування",
        "Volume Settings": "Налаштування гучності",
        "get card list for lock error": "помилка отримання списку карток для замка",
        "get card list parse fail": "не вдалося розібрати список карток",
        "get pin list for lock error": "помилка отримання списку PIN-кодів для замка",
        "get pin list parse fail": "не вдалося розібрати список PIN-кодів",
        "fingerprint code must be less than 2048 characters or empty.": "код відбитка пальця має містити менше ніж 2048 символів або бути порожнім.",
        "Personnel not in office.": "Персонал відсутній в офісі.",
        "customize form fail.": "не вдалося налаштувати форму.",
        "smart lock type error.": "помилка типу смарт-замка.",
        "invalid client id or secret": "некоректний ідентифікатор клієнта або секретний ключ",
        "invalid account or password": "некоректний обліковий запис або пароль",
        "invalid access token": "некоректний токен доступу",
        "invalid refresh token": "некоректний токен оновлення",
        "no permission to access this project": "немає дозволу на доступ до цього проекту",
        "Stay Alarm Time": "Час сигналізації залишання",
        "This function only support sl20 lock.": "Ця функція підтримується лише замком sl20.",
        "Json marshal error.": "Помилка серіалізації JSON.",
        "Json unmarshal error.": "Помилка десеріалізації JSON.",
        "Illegal request, not added within valid time.": "Неправомірний запит, не додано в межах дійсного часу.",
        "invalid nvr type": "некоректний тип NVR",
        "project is empty": "проект порожній",
        "project type is invalid": "некоректний тип проекту",
        "owner is invalid": "некоректний власник",
        "url is invalid": "некоректна URL-адреса",
        "password is invalid": "некоректний пароль",
        "building is invalid": "некоректна будівля",
        "fail to get data": "не вдалося отримати дані",
        "invalid allow pm view type": "некоректний тип дозволу перегляду PM",
        "Data not exist.": "Дані не існують.",
        "cannot find community PrivateKey.": "Не вдалося знайти приватний ключ спільноти.",
        "cannot find single PrivateKey.": "Не вдалося знайти окремий приватний ключ.",
        "The third party not exist.": "Третя сторона не існує.",
        "{0} and indoor monitors/guard phones": "{0} та внутрішні монітори/телефони охорони",
        "{0} and indoor monitors/guard phones, with phone as backup": "Спочатку {0} та внутрішні монітори/телефони охорони, потім телефон як резервний",
        "Indoor monitors/guard phones with {0} as backup": "Спочатку внутрішні монітори/телефони охорони, потім {0} як резервний",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Спочатку внутрішні монітори/телефони охорони, потім {0}, в кінці — телефон",
        "{0} Intercom Feature": "Функція домофона {0}",
        "Capture on {0}": "Знімок екрана в застосунку {0}",
        "{0} Intercom Feature is not activated or has expired.": "Функція домофону {0} не активована або термін її дії закінчився.",
        "fingerprint code must be equal 1620 characters or empty.": "код відбитка пальця має містити рівно 1620 символів або бути порожнім.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Щоб оновлення пройшло успішно, переконайтеся, що рівень заряду батареї замка понад 40% перед продовженням.",
        "Automatic Locking Time": "Час автоматичного блокування",
        "WiFi Keep-Alive": "Підтримання активності вайфаю",
        "WiFi Setting": "Налаштування WiFi",
        "Connecting the network...": "Підключення до мережі...",
        "Set successfully!": "Успішно встановлено!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Оффлайн-код можна використовувати навіть якщо замок не підключений до WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Увімкнення цієї функції збільшить енергоспоживання замка.",
        "Each offline code can only be used once.": "Кожен оффлайн-код можна використати лише один раз.",
        "Receiver Info": "Інформація про отримувача",
        "log id": "ID входу",
        "Create HW SN Config Empty SN.": "Створення конфігурації HW SN порожній SN.",
        "The SN": "Серійний номер",
        "SN can contain up to 32 characters.": "Серійний номер може містити до 32 символів.",
        "Check HW SN Not Found.": "Перевірка HW SN: не знайдено.",
        "the end user not found": "кінцевий користувач не знайдений",
        "Family Call": "Сімейний дзвінок",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Під час оновлення всі функції, пов\'язані із замком, будуть тимчасово недоступні.",
        "8-digit PIN code starting with \"9\" is invalid!": "8-значний PIN-код, що починається з \"9\", недійсний!",
        "Lock name length must be between 1 and 50": "Довжина назви замка повинна бути від 1 до 50 символів",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Кількість працівників із послугою виклику на мобільний номер не може перевищувати кількість працівників із послугою домофону {0}.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Кількість адміністраторів із послугою виклику на мобільний номер не може перевищувати кількість адміністраторів із послугою домофону {0}.",
        "charge type": "тип оплати",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Кількість персоналу зі стаціонарним зв’язком не може перевищувати кількість тих, хто користується SmartPlus Інтеркомом.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Кількість адміністраторів зі стаціонарним зв’язком не може перевищувати кількість адміністраторів, які користуються SmartPlus Інтеркомом.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Зчитувач не можна налаштувати на одночасне використання Wiegand та RS485.",
        "parameter error": "помилка параметра",
        "community name already exist": "назва спільноти вже існує",
        "personnel app without intercom feature number": "додаток персоналу без номера функції домофону",
        "check feature billing charge plan new error": "помилка перевірки нового тарифного плану функції",
        "subscription not found": "підписку не знайдено",
        "System setting record not found.": "Запис налаштувань системи не знайдено.",
        "Smart home not enabled.": "Розумний дім не увімкнено.",
        "the apt call type value is invalid.": "значення типу виклику apt недійсне.",
        "the ip call or sip call value is invalid.": "значення ip або sip виклику недійсне.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode має бути числом від 2 до 8 цифр, але не може бути 8-значним, що починається з 9, або порожнім.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard має містити символи A-F, 0-9 та бути менше 16 символів або порожнім.",
        "owner cannot be empty.": "власник не може бути порожнім.",
        "creator cannot be empty.": "створювач не може бути порожнім.",
        "the creator type value is invalid": "недійсне значення типу створювача",
        "the IsCreateByPm value is invalid": "значення IsCreateByPm недійсне",
        "the pinCode already exist": "pinCode вже існує",
        "the rfCard already exist": "rfCard вже існує",
        "license plate is invalid.": "номерний знак недійсний.",
        "owner info is invalid.": "інформація про власника недійсна.",
        "uhf is invalid.": "uhf недійсний.",
        "time control is invalid.": "контроль часу недійсний.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Ви досягли межі в 5 номерних знаків і не можете додати ще",
        "the plate already exist": "номерний знак вже існує",
        "the uhf already exist": "uhf вже існує",
        "empty community": "порожня спільнота",
        "no find license Plate": "номерний знак не знайдено",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess режим має бути 0, 1 або 2.",
        "Run field is required when mode is 1 or 2.": "Поле Run обовʼязкове, коли режим встановлено в 1 або 2.",
        "Serial field is required when mode is 2.": "Поле Serial обовʼязкове, коли режим встановлено в 2.",
        "the pin cannot be empty": "pin не може бути порожнім",
        "the rfCard cannot be empty": "rfCard не може бути порожнім",
        "the IDAccess already exist": "IDAccess вже існує",
        "the resident cannot be empty": "мешканець не може бути порожнім",
        "the fingerprint cannot be empty": "відбиток пальця не може бути порожнім",
        "the face cannot be empty": "обличчя не може бути порожнім",
        "not found pin": "pin не знайдено",
        "not found rfCard": "rfCard не знайдено",
        "not found IDAccess": "IDAccess не знайдено",
        "not found fingerprint": "відбиток пальця не знайдено",
        "not found face": "обличчя не знайдено",
        "face pic is invalid.": "фото обличчя недійсне.",
        "community build and room cannot be empty.": "будівля спільноти та кімната не можуть бути порожніми.",
        "device info mac cannot be empty.": "MAC-адреса пристрою не може бути порожньою.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "тип планувальника має бути 0,1,2 або формат часу недійсний, або dataflag не в межах 0-127.",
        "MAC address cannot be empty.": "MAC-адреса не може бути порожньою.",
        "MAC address 0C1105000000 is not allowed.": "MAC-адреса 0C1105000000 не дозволена.",
        "MAC address must be 12 hexadecimal characters.": "MAC-адреса має містити 12 шістнадцяткових символів.",
        "Scheduler type value is invalid.": "Значення типу планувальника недійсне.",
        "parse is fail": "помилка розбору",
        "the fingerprint already exist": "відбиток пальця вже існує",
        "the licensePlate cannot be empty": "номерний знак не може бути порожнім",
        "the licensePlate already exist": "номерний знак вже існує",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run має бути 10-значним числом або закінчуватися на -K.",
        "idaccess serial must be 9 digit number.": "idaccess серійний номер має бути 9-значним числом.",
        "relay not in 0-15": "реле не в діапазоні 0-15",
        "security relay not in 0-3": "реле безпеки не в діапазоні 0-3",
        "file name is wrong": "неправильна назва файлу",
        "access mode specified": "вказано режим доступу",
        "create community user accessmode failed.": "не вдалося створити режим доступу користувача спільноти.",
        "delete community user accessmode failed.": "не вдалося видалити режим доступу користувача спільноти.",
        "Cannot delete building because it has associated users.": "Неможливо видалити будівлю, оскільки з нею повʼязані користувачі.",
        "Cannot delete building because it has associated Salto devices.": "Неможливо видалити будівлю, оскільки з нею пов’язані пристрої Salto.",
        "community building not found": "будівлю спільноти не знайдено",
        "Invalid Name Display": "Недійсне відображення імені",
        "The Community does not exist.": "Спільнота не існує.",
        "Update CommunityIsInstallerKit Error.": "Помилка оновлення CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Дистриб’ютор не підтримує виклики спільноти.",
        "Community Has Special Device, Not Allowed To Delete.": "У спільноті є спеціальний пристрій, видалення неможливе.",
        "The project smart home switch must be disabled": "Перемикач розумного дому має бути вимкнений",
        "There are ITec Locks in project": "У проєкті є iTec замки",
        "There are Salto Locks in project": "У проєкті є Salto замки",
        "There are Dormakaba Locks in project": "У проєкті є Dormakaba замки",
        "It is rent manager project": "Це проєкт Rent Manager",
        "It is installer account": "Це обліковий запис монтажника",
        "contact preference type": "тип способу зв\'язку",
        "Floor list is required when not all floors.": "Список поверхів обовʼязковий, якщо не всі поверхи.",
        "Building floors list is required when all buildings.": "Список поверхів по будівлях обовʼязковий, коли всі будівлі.",
        "Indoor monitor name is required.": "Потрібна назва внутрішнього монітора.",
        "The primary account is not activated.": "Головний обліковий запис не активований.",
        "You can\'t create more family member accounts.": "Ви не можете створити більше облікових записів для членів сім\'ї.",
        "community user not found": "користувача спільноти не знайдено",
        "community is empty": "спільнота порожня",
        "the end user not master user": "кінцевий користувач не є основним користувачем",
        "the end user not member user": "кінцевий користувач не є підкористувачем",
        "The email already exists and cannot be repeated": "Ця електронна пошта вже існує, не можна повторно використовувати",
        "The mobile Number already exists": "Мобільний номер вже існує",
        "The room number format error.": "Помилка формату номера кімнати.",
        "community not found": "спільноту не знайдено",
        "resident not found": "мешканця не знайдено",
        "installer not found": "монтажника не знайдено",
        "Operation Failed!": "Операцію не виконано!",
        "You don\'t have operate permission": "У вас немає дозволу на виконання цієї операції",
        "You cannot select Relay and Door at the same time": "Ви не можете вибрати реле та двері одночасно",
        "user don\'t active": "користувач не активований",
        "User has expired": "Користувач прострочений",
        "timestamp must be within 3 minutes of current server time": "мітка часу має бути в межах 3 хвилин від поточного часу сервера",
        "cannot find single rf Card.": "неможливо знайти окрему rfCard.",
        "cannot find community rf Card.": "неможливо знайти rfCard спільноти.",
        "smartLock model": "модель smartLock",
        "the project does not open smart home": "у цьому проєкті не активовано розумний дім",
        "php web server error": "помилка PHP веб-сервера",
        "Ins not found.": "Ins не знайдено.",
        "RentManage Unit Not Set.": "Одиницю RentManage не встановлено.",
        "add audit log error": "помилка додавання аудиту",
        "check building in error": "помилка перевірки будівлі",
        "Special devices cannot be deleted": "Спеціальні пристрої не можуть бути видалені",
        "the email is empty": "електронна пошта порожня",
        "the email format is incorrect": "неправильний формат електронної пошти",
        "the mobile number is empty": "мобільний номер порожній",
        "the mobile number format is incorrect": "неправильний формат мобільного номера",
        "Site not found": "Проєкт не знайдено",
        "User not found": "Користувача не знайдено",
        "invalid time format": "некоректний формат часу",
        "ground floor type": "Формат проміжного поверху",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Помилка діапазону початкового поверху, допустимі значення: від -10 до -1, G0, G1, G2, від 1 до 128.",
        "Building ID must be between 1 and 99.": "ID будівлі має бути від 1 до 99.",
        "Community building name": "Назва будівлі спільноти",
        "Building ID already exists in this community.": "ID цієї будівлі вже існує в цій спільноті.",
        "building ID": "ID будівлі",
        "Community building not found.": "Будівлю спільноти не знайдено.",
        "Cannot delete building because it has associated devices.": "Неможливо видалити будівлю, оскільки до неї привʼязані пристрої.",
        "project is not valid": "проєкт недійсний",
        "Cannot delete building because it has associated salto devices.": "Неможливо видалити будівлю, оскільки до неї підключені пристрої salto.",
        "Cannot delete building because it has associated iTec devices.": "Неможливо видалити будівлю, оскільки до неї підключені пристрої iTec.",
        "Cannot delete building because it has associated dormakaba devices.": "Неможливо видалити будівлю, оскільки до неї підключені пристрої dormakaba.",
        "member limit num": "обмеження кількості учасників",
        "Indoor Monitor No Set Error.": "Помилка: внутрішній монітор не налаштовано.",
        "The room not has indoor": "У кімнаті немає внутрішнього пристрою",
        "check user in building error": "перевірка користувача у помилковій будівлі",
        "The name specified is already in use.": "Вказане ім’я вже використовується.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Цей часовий проміжок перекривається з існуючим. Будь ласка, змініть його.",
        "This door status changed. Please try again.": "Статус цієї двері змінився. Будь ласка, спробуйте ще раз.",
        "the lock can\'t bind this community": "цей замок не може прив’язати цю спільноту",
        "The custom quantity limit has been exceeded!": "Перевищено власне обмеження кількості!",
        "This time span overlaps with an existing one. Please adjust it.": "Цей часовий проміжок перекривається з існуючим. Будь ласка, відкоригуйте його.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Цей одноразовий розклад перекривається з чинним одноразовим розкладом. Будь ласка, відкоригуйте його.",
        "Operation Failed. Please try again.": "Операцію не вдалося виконати. Будь ласка, спробуйте ще раз.",
        "The image is not a front view.": "Зображення не є фронтальним видом.",
        "A mask was detected.": "Виявлено маску.",
        "The image resolution is too low.": "Роздільна здатність зображення занадто низька.",
        "No face was detected.": "Обличчя не виявлено.",
        "The file size is too large.": "Розмір файлу занадто великий.",
        "The face in the image is too large.": "Обличчя на зображенні занадто велике.",
        "The face in the image is too small.": "Обличчя на зображенні занадто маленьке.",
        "Multiple faces detected.": "Виявлено кілька облич.",
        "The face is not clear enough.": "Обличчя недостатньо чітке.",
        "Face detection failed.": "Не вдалося виявити обличчя.",
        "Please enter a value between 1 and 9999": "Будь ласка, введіть значення від 1 до 9999",
        "Please select which input your door sensor is connected to.": "Будь ласка, виберіть, до якого входу підключений ваш датчик дверей.",
        "Add temp key failed, please try it again": "Не вдалося додати тимчасовий ключ, будь ласка, спробуйте ще раз",
        "Dis Not Support Dynamic QRCode Error.": "Помилка: дистриб’ютор не підтримує динамічний QR-код.",
        "QR code not exist": "QR-код не існує",
        "The temp key has expired.": "Тимчасовий ключ закінчився.",
        "The device is not in the office": "Пристрій не перебуває в офісі",
        "The device is already assigned.": "Пристрій уже призначено.",
        "The device cannot be assigned to any user.": "Пристрій не може бути призначений жодному користувачу.",
        "You cannot select an option with fewer users than the current project members.": "Ви не можете вибрати опцію з меншою кількістю користувачів, ніж кількість поточних учасників проєкту.",
        "File check failed. Please download the latest template and try again.": "Перевірка файлу не вдалася. Будь ласка, завантажте найновіший шаблон і спробуйте ще раз.",
        "Dynamic QR Code not active.": "Динамічний QR-код не активний.",
        "Dynamic QR Code not enable.": "Динамічний QR-код не активовано.",
        "{0} not found.": "{0} не знайдено.",
        "Tier charge plan": "План тарифікації за рівнями",
        "Feature billing charge plan new": "План нової функції виставлення рахунків",
        "Feature billing gradient charge plan": "План градієнтної оплати за функціями",
        "The exit time cannot be earlier than the entry time.": "Час виходу не може бути ранішим за час входу.",
        "User Name or Password": "Ім\'я користувача або пароль",
        "You can only link up to 5 sites.": "Ви можете пов\'язати не більше 5 локацій.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Цей номерний знак уже зареєстровано за мешканцем і його не можна додати до чорного списку.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Цей номерний знак внесено до чорного списку, і його не можна зареєструвати як транспортний засіб.",
        "Elevator not configured in company access floor.": "Ліфт не налаштовано на поверхах доступу компанії.",
        "the device is not in the office": "Пристрій не перебуває в офісі",
        "A maximum of 1000 data items can be imported": "Можна імпортувати не більше 1000 елементів даних",
        "Exit time cannot be later than the current time.": "Час виходу не може бути пізнішим за поточний час.",
        "You can only import a file at a time in the current parking lot.": "На поточній автостоянці ви можете імпортувати лише один файл за раз.",
        "The license plate is already in the blocklist.": "Цей номерний знак уже у чорному списку.",
        "Building name too long.": "Назва будівлі занадто довга.",
        "Unlock failed. Permission denied by user.": "Не вдалося розблокувати. Дозвіл відхилено користувачем.",
        "Please remove the sensor device(s) before disabling this feature.": "Будь ласка, видаліть пристрій(ї) датчика перед вимкненням цієї функції.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Операцію не вдалося виконати! Для цього користувача перевищено денний ліміт у 15 записів.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "У межах одного проєкту можна додати до {0} публічних пристроїв. Щоб додати більше, зверніться до технічної підтримки Akuvox за адресою support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "У межах одного проєкту можна додати до {0} облікових записів персоналу. Щоб додати більше, зверніться до технічної підтримки Akuvox за адресою support{'@'}akuvox.com.",
        "cancel": "Скасувати",


    }
};
